export default __webpack_public_path__ + "static/stars-4788901c923f561825411f7dec90a0a1.svg";